/** Cores compartilhadas do gráfico do M6 (eixos, grid, overlays). */
export const AXIS = '#94a3b8';
export const GRID = '#1a2c4a';
export const REGUA_COLOR = '#22c55e';
export const PLUV_COLOR = '#38bdf8';
/**
 * GUPM-270 — 2ª série do tiltímetro (eixo B). Roxo por não colidir com a cor de
 * identidade da barragem (que pinta o eixo A) nem com a escala de severidade
 * amarelo/laranja/vermelho das linhas de referência. A distinção principal é a
 * forma (traço tracejado); a cor é reforço.
 */
export const EIXO_B_COLOR = '#a78bfa';
